export default __webpack_public_path__ + "static/media/Arianna_e_Lio.24b034b0.jpg";